export function formatDocumentVersionLabel(versionNumber) {
    if (versionNumber == null || !Number.isFinite(versionNumber) || versionNumber <= 0) {
        return undefined;
    }
    return `v${Math.trunc(versionNumber)}`;
}
